import { mapGetters } from 'vuex'
import { getAllValidVariablesTitle } from '@/modules/maria/helpers/variables'

export const channelsForm = {
  components: {
    OfferTypeOptionsMenu: () => import('@/modules/maria/campanha-da-maria-v2/views/components/ChannelsConfiguration/OfferTypeOptionsMenu.vue'),
  },
  props: {
    settingsId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    campaignSettings: {},
    selectedOfferType: 'offer_sales',
  }),
  beforeMount() {
    document.documentElement.style.scrollBehavior = 'auto'
    document.body.style.scrollBehavior = 'auto'

    window.scrollTo(0, 0)

    this.$nextTick(() => {
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = 'smooth'
        document.body.style.scrollBehavior = 'smooth'
      }, 100)
    })
  },
  mounted() {
    this.campaignSettings = this.campaign.messages_dispatcher.settings.schedule_settings.find((schedule_settings) => schedule_settings.id === this.settingsId)

    if (!this.campaignSettings) {
      this.$snackbar({ message: 'Configurações do canal não encontradas.', snackbarColor: 'error' })
    }

    this.selectedOfferType = this.offerTypeOptions[0].value
  },
  computed: {
    ...mapGetters(['campaign']),
    offerTypeOptions() {
      const items = []
      if (this.campaign?.offer_sales?.length > 0) {
        items.push({ text: 'Desconto Absoluto', value: 'offer_sales' })
        return items
      }

      const offerSchedules = this.campaign?.offer_schedules || []

      const hasOfferSales = offerSchedules.some((schedule) => schedule.offer_sales.length > 0)
      if (hasOfferSales) {
        items.push({ text: 'Desconto Absoluto', value: 'offer_sales' })
      }
      const hasPercentageOfferSales = offerSchedules.some((schedule) => schedule.percentage_offer_sales.length > 0)
      if (hasPercentageOfferSales) {
        items.push({ text: 'Desconto Percentual', value: 'percentage_offer_sales' })
      }
      const hasCashbackAbsoluteOfferSales = offerSchedules.some((schedule) => schedule.cashback_absolute_offer_sales.length > 0)
      if (hasCashbackAbsoluteOfferSales) {
        items.push({ text: 'Cashback Absoluto', value: 'cashback_absolute_offer_sales' })
      }
      const hasCashbackPercentageOfferSales = offerSchedules.some((schedule) => schedule.cashback_percentage_offer_sales.length > 0)
      if (hasCashbackPercentageOfferSales) {
        items.push({ text: 'Cashback Percentual', value: 'cashback_percentage_offer_sales' })
      }
      const hasTakepayOfferSales = offerSchedules.some((schedule) => schedule.takepay_offer_sales.length > 0)
      if (hasTakepayOfferSales) {
        items.push({ text: 'Leve e Pague', value: 'takepay_offer_sales' })
      }
      const hasPointsOfferSales = offerSchedules.some((schedule) => schedule.points_offer_sales.length > 0)
      if (hasPointsOfferSales) {
        items.push({ text: 'Pontos', value: 'points_offer_sales' })
      }
      const hasComboOfferSales = offerSchedules.some((schedule) => schedule.combo_offer_sales.length > 0)
      if (hasComboOfferSales) {
        items.push({ text: 'Combo', value: 'combo_offer_sales' })
      }

      return items
    },
    isFormDisabled() {
      return !this.campaignSettings
    },
  },
  methods: {
    extractVariables(text) {
      if (!text) return []

      const variables = []

      const regex = /\[[^\]]*\]/g
      let match
      while ((match = regex.exec(text)) !== null) {
        const extractedText = match[0]
        const content = extractedText.slice(1, -1)

        if (content.includes('[') || content.includes(']')) {
          variables.push(extractedText)
        } else {
          const validVariables = getAllValidVariablesTitle()
          if (!validVariables.includes(extractedText)) {
            variables.push(extractedText)
          }
        }
      }

      const openBracketRegex = /\[[^\]]*$/g
      while ((match = openBracketRegex.exec(text)) !== null) {
        variables.push(match[0])
      }

      return variables
    },
    validateVariables(text) {
      if (!text) return []

      const validVariables = getAllValidVariablesTitle()
      const usedVariables = this.extractVariables(text)
      const errors = []

      const invalidVariables = usedVariables.filter((variable) => {
        if (!variable.endsWith(']')) {
          return true
        }

        if (!variable.startsWith('[')) {
          return true
        }

        return !validVariables.includes(variable)
      })

      invalidVariables.forEach((variable) => {
        errors.push(`Variável "${variable}" inválida.`)
      })

      return errors
    },
  },
}
